const emptyArray: unknown[] = [];

// Ensure that getEmptyArray() === getEmptyArray() is true.
function getEmptyArray<T>() {
  return emptyArray as T[];
}

export default getEmptyArray;
